import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect } from 'react';
import { WarningAmber } from '@mui/icons-material';

type Props = {
  title: string;
  message: string;
  close: any;
  handleSaveBtn?: any;
  button?: {
    saveLabel: string;
    closeLabel: string;
  };
};

function ConfirmationNormalPopupModal({
  handleSaveBtn,
  message,
  title,
  close,
  button = {
    saveLabel: 'Save',
    closeLabel: 'Cancel',
  },
}: Props) {
  return (
    <Box>
      <Stack
        flexDirection="row"
        p={'2rem'}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{
            backgroundColor: 'rgba(247, 144, 9, 0.12)',
            padding: '4px',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            margin: '16px 4px 0px 16px',
          }}
        >
          <WarningAmber sx={{ color: '#B54708' }} />
        </Stack>
        <Stack>
          <DialogTitle sx={{ padding: '16px 14px 10px 14px ' }}>
            <Typography variant="h5">{title}</Typography>
          </DialogTitle>
          <DialogContent sx={{ padding: '0px 14px 10px 14px !important' }}>
            <Typography
              sx={{ color: '#6C737F' }}
              variant="body2"
            >
              {message}
            </Typography>
          </DialogContent>
        </Stack>
      </Stack>
      <DialogActions>
        <Button
          autoFocus
          color="inherit"
          onClick={close}
        >
          {button.closeLabel}
        </Button>
        <Button
          autoFocus
          variant="contained"
          onClick={handleSaveBtn}
        >
          {button.saveLabel}
        </Button>
      </DialogActions>
    </Box>
  );
}

export default ConfirmationNormalPopupModal;
